<div class="modal" [ngClass]="{'is-active': opened && isValid(src)}" (click)="close()">
    <div class="modal-background"></div>
    <div class="modal-content">
        <p class="image">
            <img [src]="src">
        </p>
    </div>
</div>
